import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type CreateQRCodeImageMutationVariables = Types.Exact<{
  data: Types.CreateQRCodeInput;
}>;

export type CreateQRCodeImageMutation = { __typename?: 'Mutation'; createQRCode: string };

export const CreateQRCodeImageDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateQRCodeImage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateQRCodeInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createQRCode' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateQRCodeImageMutationFn = Apollo.MutationFunction<CreateQRCodeImageMutation, CreateQRCodeImageMutationVariables>;

/**
 * __useCreateQRCodeImageMutation__
 *
 * To run a mutation, you first call `useCreateQRCodeImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQRCodeImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQrCodeImageMutation, { data, loading, error }] = useCreateQRCodeImageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateQRCodeImageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateQRCodeImageMutation, CreateQRCodeImageMutationVariables>) {
  return ApolloReactHooks.useMutation<CreateQRCodeImageMutation, CreateQRCodeImageMutationVariables>(CreateQRCodeImageDocument, baseOptions);
}
export type CreateQRCodeImageMutationHookResult = ReturnType<typeof useCreateQRCodeImageMutation>;
export type CreateQRCodeImageMutationResult = Apollo.MutationResult<CreateQRCodeImageMutation>;
export type CreateQRCodeImageMutationOptions = Apollo.BaseMutationOptions<CreateQRCodeImageMutation, CreateQRCodeImageMutationVariables>;
